import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * FranceKeyFigures Widget
 */
@Component({
  selector: 'france-key-figures-widget',
  templateUrl: './france-key-figures-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './france-key-figures-widget.component.scss']
})
export class FranceKeyFiguresWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'franceKeyFigures', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    const self = this;//Kendo - keep it

    this.textAreaOptions = {
      change: function () {
        self.setDirtyFlag(true);
      },
      update: function (text) {
        self.widgetData.Comment = text;
      },
    };

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("franceKeyFigures", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('franceKeyFigures').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('franceKeyFigures', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Checks if value is valid year
   * @param value {any} Value
   */
  private isValidYear(value) {
    return !(value == null || value == "" || value == "0");
  }

  /**
   * Returns formatted Year of Construction
   */
  getYearOfConstructionFormatted(): string {
    const value = this.widgetData.yearOfConstruction;
    const value2 = this.widgetData.yearOfConstruction2;
    const value3 = this.widgetData.yearOfConstruction3;
    const value4 = this.widgetData.yearOfConstruction4;
    const value5 = this.widgetData.yearOfConstruction5;

    if (!this.isValidYear(value)) {
      return this.reportDesignerTranslator.getString('common.notAvailable');
    } else {
      let str = "";
      str += (this.isValidYear(value5) ? (value5 + " / ") : "");
      str += (this.isValidYear(value4) ? (value4 + " / ") : "");
      str += (this.isValidYear(value3) ? (value3 + " / ") : "");
      str += (this.isValidYear(value2) ? (value2 + " / ") : "");
      str += (this.isValidYear(value) ? (value) : "");

      return str;
    }
  }

  /**
   * Returns formatted Year of Refurbishment
   */
  getYearOfRefurbishmentFormatted(): string {
    const value = this.widgetData.yearOfRefurbishment;
    const value2 = this.widgetData.yearOfRefurbishment2;
    const value3 = this.widgetData.yearOfRefurbishment3;
    const value4 = this.widgetData.yearOfRefurbishment4;
    const value5 = this.widgetData.yearOfRefurbishment5;

    if (!this.isValidYear(value)) {
      return this.reportDesignerTranslator.getString('common.notAvailable');
    } else {
      let str = "";
      str += (this.isValidYear(value5) ? (value5 + " / ") : "");
      str += (this.isValidYear(value4) ? (value4 + " / ") : "");
      str += (this.isValidYear(value3) ? (value3 + " / ") : "");
      str += (this.isValidYear(value2) ? (value2 + " / ") : "");
      str += (this.isValidYear(value) ? (value) : "");

      return str;
    }
  }
}
